import { CATEGORIES } from './constants';

export const getStudentCategories = (messages, activeStudent) => {
  if (!activeStudent) return new Set([CATEGORIES.ALL]);
  
  const categories = new Set([CATEGORIES.ALL]);
  messages
    .filter(msg => msg.names.includes(activeStudent))
    .forEach(msg => categories.add(msg.category));
  
  return categories;
};

export const getCategoryCount = (messages, student, category) => {
  return messages.filter(msg => 
    msg.names.includes(student) && 
    (category === CATEGORIES.ALL || msg.category === category)
  ).length;
};

export const getFilteredMessages = (messages, activeStudent, activeCategory) => {
  if (!activeStudent) return [];
  
  console.debug('Filtering messages:', {
    totalMessages: messages.length,
    activeStudent,
    activeCategory,
    matchingMessages: messages.filter(msg => msg.names.includes(activeStudent)).length
  });
  
  return messages.filter(msg => {
    const matchesStudent = msg.names.includes(activeStudent);
    const matchesCategory = activeCategory === CATEGORIES.ALL || msg.category === activeCategory;
    return matchesStudent && matchesCategory;
  });
};

/*export const scrollToMessage = (messageId) => {
  const element = document.getElementById(`message-${messageId}`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};*/

export const getRandomDefaultPhoto = () => {
  const DEFAULT_PHOTOS = [
    require('../images/bertaface.jpg'),
    require('../images/galface_1.jpg'),
    require('../images/galface_2.jpg'),
    require('../images/guyface_1.jpg'),
    require('../images/guyface_2.jpg'),
    require('../images/guyface_3.jpg'),
    require('../images/Headshot_1to1.jpg'),
    require('../images/sammyface.jpg')
  ];
  return DEFAULT_PHOTOS[Math.floor(Math.random() * DEFAULT_PHOTOS.length)];
};

export const createNewProfile = (name) => {
  return {
    name,
    photo: getRandomDefaultPhoto(),
    // ... other profile properties ...
  };
};